const catalogContexts = {
  sales: "sales",
  swap: "swap",
  wishlist: "wishlist",
  userlist: "userlist",
};

export default catalogContexts;
